export const ROOT_URL = window.location.host

// Attention: The following env variable names are used in codegen.yml, and container-start.sh
export const GLOBAL_API = process.env.REACT_APP_GLOBAL_API
export const GLOBAL_FILE_HANDLER_API = process.env.REACT_APP_GLOBAL_FILE_HANDLER_API

export const GEOLOCATION_API = 'https://api.geoapify.com/v1'
export const GEOLOCATION_API_KEY = process.env.REACT_APP_GEOLOCATION_API_KEY
